<template>
  <section class="payment">
    <div class="inner">
      <paragraph-header size="2">{{ $t('Payment Form') }}</paragraph-header>
      <div class="form" ref="form">
        <transition name="fade">
          <div v-if="msg" v-html="msg"></div>
        </transition>
        <the-loader v-if="waitingForReservation" :isAbsolute="true"></the-loader>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { PlanyoService } from '@/api'
import TheLoader from './TheLoader.vue'
import ParagraphHeader from '../atoms/ParagraphHeader.vue'
export default {
  components: { ParagraphHeader, TheLoader },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Payment',
    // all titles will be injected into this template
    titleTemplate: '%s | LeihBOX',
  },
  data() {
    return {
      waitingForReservation: false,
      msg: '',
      showOverlay: false,
      reduceOpacity: false,
    }
  },
  computed: {
    ...mapState('cart', ['reservationsResponse']),
  },
  created() {},
  async mounted() {
    await this.getPaymentForm()

    this.$nextTick(() => {
      const planyoPaymentForms = document.getElementById('payment_forms')

      if (!planyoPaymentForms) {
        const url = new URL(window.location)
        url.searchParams.delete('step')
        url.searchParams.set('mode', 'payment_confirmation')
        url.searchParams.set('reservation_id', this.firstReservationID)
        return (window.location.href = url)
      }

      const planyoScripts = Array.prototype.slice
        .call(planyoPaymentForms.parentElement.getElementsByTagName('script'))
        .slice(0, 3)

      const { set } = this.$meta().addApp('custom')

      planyoScripts.forEach((script) => {
        set({
          script: [
            {
              innerHTML: script.innerHTML,
              type: 'text/javascript',
              body: true,
            },
          ],
        })
      })
    })
  },
  methods: {
    async getPaymentForm() {
      this.waitingForReservation = true
      this.showOverlay = true

      const url = new URL(window.location)

      this.firstReservationID = this.findGetParameter('reservation_id')
      if (!this.firstReservationID) return (window.location.href = url)

      const paymentTemplate = await PlanyoService.getPaymentTemplate(this.firstReservationID)
      this.waitingForReservation = false
      this.msg = paymentTemplate.data
    },
    findGetParameter(parameterName) {
      var result = null,
        tmp = []
      var items = location.search.substr(1).split('&')
      for (var index = 0; index < items.length; index++) {
        tmp = items[index].split('=')
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
      }
      return result
    },
  },
}
</script>

<style lang="scss" scoped>
.payment {
  width: 100%;

  .inner {
    @include container;
  }

  .form {
    @include fontStyleCopyRegular;
    position: relative;
    width: 100%;
    min-height: 40vh;
    margin-top: 30px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
